import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseComponent } from 'src/app/features/base-component';

@Component({
  selector: 'digi-email',
  templateUrl: './input-email.component.html',
  styleUrl: './input-email.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputEmailComponent extends BaseComponent {
  @Input() label: string = 'Email';
  @Input() placeholder: string = '';
  @Input() control!: FormControl;
  @Input() errorMessage: string = ''; 
  @Input() isSubmit: boolean = false;
  @Input() icon: boolean = false;
  @Input() isAddUserPage: boolean = false;
  isReadonly = true;
}
